// attendeesRepository.js
// API repository for attendees-related backend calls
import { buildApiUrl } from './apiUtils.js';

export const AttendeesRepository = {
    async fetchAttendees(eventId) {
        const params = new URLSearchParams({ eventId: eventId, club: 'gdynia-padel-club' });
        const response = await fetch(`${buildApiUrl('/attendees')}?${params.toString()}`, {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) throw new Error('Błąd ładowania uczestników: ' + response.statusText);
        const data = await response.json();
        return data.normal;
    }
};

export default AttendeesRepository;
